// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M12.18 3.02C15.27 5.62 15.27 10.38 12.18 12.98',
  'M3.82 12.98C0.73 10.38 0.73 5.62 3.82 3.02',
  'M10.54 4.97C12.42 6.55 12.42 9.45 10.54 11.03',
  'M5.46 11.03C3.58 9.45 3.58 6.55 5.46 4.97',
  'M9.4 8C9.4 8.77 8.77 9.4 8 9.4C7.23 9.4 6.6 8.77 6.6 8C6.6 7.23 7.23 6.6 8 6.6C8.77 6.6 9.4 7.23 9.4 8Z',
];
